module.exports = __webpack_public_path__ + "static/secondBaner-9003a0f79f95505177f32bfc682a602d.png";